module.exports = __webpack_public_path__ + "static/sunrise-ff45dcdcee1ded58d17ffcb2ec2f650e.mp4";